import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCallback } from './App.hooks';
import { NAVBAR_ICON_URL } from '../../constants';

import config from '../../config';

import DateToken from '../../views/date-token/DateToken';

import styles from './Callback.module.css';
import { IS_AUTHENTICATED_KEY } from '@/auth/constants';

export const Callback = () => {
	if (config?.app?.auth?.enabled && config.app?.auth.type === 'date-token') {
		return <DateToken />;
	}

	return <DefaultCallback />;
};

function DefaultCallback() {
	const navigate = useNavigate();
	const { isLoading, error, isActive } = useCallback();

	useEffect(() => {
		if (isLoading) {
			return;
		}

		if (isActive) {
			setTimeout(() => {
				localStorage.setItem(IS_AUTHENTICATED_KEY, 'true');
				navigate('/', { replace: true });
			}, 2000);
			return;
		}

		const invalidAuthenticationUrl =
			config.build.links?.invalidAuthenticationUrl;
		if (invalidAuthenticationUrl) {
			window.location.href = invalidAuthenticationUrl;
		}
	}, [isActive, isLoading]);

	if (error) {
		return <div style={{ color: 'black' }}>{error.message}</div>;
	}
	if (isLoading) {
		return <Loading />;
	}

	if (!isActive) {
		return <div />;
	}

	return <Loading />;
}

function Loading() {
	return (
		<div className={styles['loading']}>
			<img
				src={NAVBAR_ICON_URL}
				alt="Logo"
				className="animate__animated animate__pulse animate__fast animate__infinite"
			/>
		</div>
	);
}
